import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export interface RISARedirectDTO {
  risaRedirectUrl: string;
}

const fetchRISARedirectUrl = (clientId: string): Promise<RISARedirectDTO> =>
  authFetch(
    urlWithParams('/Consumer/RISA', {
      clientId,
    }),
  );

export const useRISAQuery = (clientId: string) =>
  useQuery(queryKeys.RISA(clientId), () => fetchRISARedirectUrl(clientId));
